<template>
  <div>
    <v-btn
      title="Configuração geral"
      color="transparent"
      fab
      elevation="0"
      @click="abrirDialogConfiguracaoGeral()"
    >
      <v-icon>mdi-cogs</v-icon>
    </v-btn>

    <SysDialog
      v-model="DIALOG_COMPUTED"
      :titulo="TITULO_DIALOG_COMPUTED"
      largura="800"
      ocultarAcoes
      @click:hidden-dialog="fecharDialog()"
    >
      <v-tabs v-model="tab" centered>
        <v-tab>Projeção Aplicada</v-tab>
        <v-tab>Aplicar Estoque</v-tab>
        <v-tab>Projeção</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ProjecaoAplicada />
        </v-tab-item>
        <v-tab-item>
          <ConfiguracaoDeEstoque />
        </v-tab-item>
        <v-tab-item>
          <CongelarProjecao />
        </v-tab-item>
      </v-tabs-items>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { mapGetters } from 'vuex';
import ProjecaoAplicada from './ProjecaoAplicada.vue';
import ConfiguracaoDeEstoque from './ConfiguracaoDeEstoque.vue';
import CongelarProjecao from './CongelarProjecao.vue';

export default {
  components: {
    SysDialog,
    ProjecaoAplicada,
    ConfiguracaoDeEstoque,
    CongelarProjecao
  },
  data: () => ({
    dialog: false,
    tab: null,
  }),
  computed: {
    ...mapGetters({
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
      GET_DIALOG_CONFIGURACAO_GERAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_GERAL',
      GET_DIALOG_CONFIGURACAO_INDIVIDUAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_INDIVIDUAL',
    }),
    DIALOG_COMPUTED: {
      get() { return this.dialog },
      set(value) { this.dialog = value; }
    },
    TITULO_DIALOG_COMPUTED() {
      return this.GET_FORM_NOVO_EVENTO.nome_evento != ''
        ? 'Configurações do evento:' + ` ${this.GET_FORM_NOVO_EVENTO.nome_evento}`
        : 'Configurações Gerais dos Eventos';
    },
  },
  watch: {
    GET_DIALOG_CONFIGURACAO_GERAL(valor) {
      this.DIALOG_COMPUTED = valor;
    },
    GET_DIALOG_CONFIGURACAO_INDIVIDUAL(valor) {
      this.DIALOG_COMPUTED = valor;
    },
  },
  methods: {
    abrirDialogConfiguracaoGeral() {
      this.$store.dispatch('EventoSazonalFinal/setDialogConfiguracaoGeral', true);
    },
    fecharDialog() {
      this.$store.dispatch('EventoSazonalFinal/setDialogConfiguracaoGeral', false);
      this.$store.dispatch('EventoSazonalFinal/setDialogConfiguracaoIndividual', false);
    }
  }
}
</script>
